export default "__VITE_ASSET__DskO7O09__"